(function () {
  if (typeof window === 'undefined' || window.SwishSystemIntake) {
    return;
  }

  function cleanString(value) {
    return value == null ? '' : String(value).trim();
  }

  function normalizeKey(value) {
    return cleanString(value)
      .toLowerCase()
      .replace(/[\[\]]/g, '')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseFieldLabel(name) {
    const match = String(name || '').match(/^contact\[(.+)\]$/);
    return normalizeKey(match ? match[1] : name);
  }

  function isNamedContactField(element) {
    return Boolean(element && element.name && /^contact\[/.test(element.name));
  }

  function isUploadField(element) {
    return Boolean(
      element &&
      element.getAttribute &&
      (
        element.hasAttribute('data-contact-upload-input') ||
        element.hasAttribute('data-contact-upload-hidden')
      )
    );
  }

  function isHiddenSystemField(element) {
    return Boolean(
      element &&
      String(element.type || '').toLowerCase() === 'hidden' &&
      !isUploadField(element)
    );
  }

  function isCheckboxLikeField(element) {
    var type = String((element && element.type) || '').toLowerCase();
    return type === 'checkbox' || type === 'radio';
  }

  function getElementValue(element) {
    if (!element) return '';

    if (element.dataset && typeof element.dataset.swishUserValue === 'string') {
      return cleanString(element.dataset.swishUserValue);
    }

    if (isCheckboxLikeField(element)) {
      return element.checked ? cleanString(element.value) : '';
    }

    return cleanString(element.value);
  }

  function getNamedContactFields(form) {
    return Array.prototype.slice.call(
      form.querySelectorAll('input[name^="contact["], textarea[name^="contact["], select[name^="contact["]')
    );
  }

  function getAssociatedLabelText(form, field) {
    if (!form || !field || !field.id || !form.querySelector) {
      return '';
    }

    try {
      var escapedId = field.id.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
      var label = form.querySelector('label[for="' + escapedId + '"]');
      return label ? cleanString(label.textContent || '') : '';
    } catch (error) {
      return '';
    }
  }

  function getFieldKeys(form, field) {
    var keys = [];
    var seen = Object.create(null);
    var candidates = [
      parseFieldLabel(field && field.name),
      field && field.getAttribute ? field.getAttribute('data-swish-field-key') : '',
      field && field.getAttribute ? field.getAttribute('aria-label') : '',
      field && field.getAttribute ? field.getAttribute('placeholder') : '',
      getAssociatedLabelText(form, field)
    ];

    candidates.forEach(function (candidate) {
      var normalized = normalizeKey(candidate);
      if (!normalized || seen[normalized]) {
        return;
      }
      seen[normalized] = true;
      keys.push(normalized);
      if (normalized.indexOf('your ') === 0) {
        var withoutYour = normalized.slice(5).trim();
        if (withoutYour && !seen[withoutYour]) {
          seen[withoutYour] = true;
          keys.push(withoutYour);
        }
      }
    });

    return keys;
  }

  function fieldMatchesLabels(form, field, labels) {
    var normalizedLabels = labels.map(normalizeKey);
    var keys = getFieldKeys(form, field);

    for (var index = 0; index < keys.length; index += 1) {
      if (normalizedLabels.indexOf(keys[index]) !== -1) {
        return true;
      }
    }

    return false;
  }

  function pickStructuredFieldValue(form, labels, options) {
    var settings = options || {};
    var allowedTypes = settings.allowedTypes || null;
    var allowHidden = Boolean(settings.allowHidden);
    var fields = getNamedContactFields(form);

    for (var index = 0; index < fields.length; index += 1) {
      var field = fields[index];
      if (!fieldMatchesLabels(form, field, labels)) {
        continue;
      }

      if (!allowHidden && isHiddenSystemField(field)) {
        continue;
      }

      if (allowedTypes && allowedTypes.indexOf(String(field.tagName || '').toLowerCase()) === -1) {
        continue;
      }

      var value = getElementValue(field);
      if (value) {
        return value;
      }
    }

    return '';
  }

  function normalizeSummaryLine(value) {
    return cleanString(value)
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function buildGeneratedSummaryLines(form) {
    var fields = getNamedContactFields(form);
    var ignoredKeys = {
      body: true,
      message: true,
      notes: true,
      'how can we help': true,
      'source website': true,
      'source page': true,
      'popup form': true,
      'popup trigger key': true,
      'swish intake id': true
    };
    var lines = [];

    for (var index = 0; index < fields.length; index += 1) {
      var field = fields[index];
      var key = parseFieldLabel(field.name);
      if (!key || ignoredKeys[key] || isHiddenSystemField(field) || isUploadField(field)) {
        continue;
      }

      var value = getElementValue(field);
      if (!value) {
        continue;
      }

      lines.push(normalizeSummaryLine(key + ': ' + value));
    }

    return lines;
  }

  function looksLikeGeneratedSummary(value, form) {
    var text = cleanString(value);
    if (!text) return false;

    var bodyLines = text
      .split(/\r?\n/)
      .map(normalizeSummaryLine)
      .filter(Boolean);

    if (bodyLines.length < 2) {
      return false;
    }

    var summaryLines = buildGeneratedSummaryLines(form);
    if (summaryLines.length < 2) {
      return false;
    }

    var summarySet = Object.create(null);
    for (var index = 0; index < summaryLines.length; index += 1) {
      summarySet[summaryLines[index]] = true;
    }

    for (var lineIndex = 0; lineIndex < bodyLines.length; lineIndex += 1) {
      if (!summarySet[bodyLines[lineIndex]]) {
        return false;
      }
    }

    return true;
  }

  function resolveStructuredNoteValue(form) {
    var noteValue = pickStructuredFieldValue(
      form,
      ['notes', 'message', 'how can we help', 'body'],
      {
        allowedTypes: ['textarea', 'input']
      }
    );

    if (!noteValue || looksLikeGeneratedSummary(noteValue, form)) {
      return '';
    }

    return noteValue;
  }

  function collectExplicitUploadUrls(form, previewUrls, logoUrls) {
    var urls = [];
    var seen = Object.create(null);
    var previewSet = Object.create(null);
    var logoSet = Object.create(null);
    var uploadFields = Array.prototype.slice.call(
      form.querySelectorAll('[data-contact-upload-hidden="true"]')
    );

    previewUrls.forEach(function (url) {
      previewSet[url] = true;
    });
    logoUrls.forEach(function (url) {
      logoSet[url] = true;
    });

    uploadFields.forEach(function (field) {
      collectUrls(getElementValue(field)).forEach(function (url) {
        if (previewSet[url] || logoSet[url] || seen[url]) {
          return;
        }

        seen[url] = true;
        urls.push(url);
      });
    });

    return urls;
  }

  function generateIntakeId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return `swish-${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
  }

  function ensureIntakeIdField(form) {
    let field = form.querySelector('[data-swish-intake-id-field]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'contact[Swish Intake ID]';
      field.setAttribute('data-swish-intake-id-field', 'true');
      form.appendChild(field);
    }

    if (!cleanString(field.value)) {
      field.value = generateIntakeId();
    }

    return field.value;
  }

  function collectRawFields(form) {
    const data = new FormData(form);
    const raw = Object.create(null);

    data.forEach((value, name) => {
      if (!/^contact\[/.test(name)) return;
      if (value instanceof File) return;

      const key = parseFieldLabel(name);
      if (!key) return;

      const text = cleanString(value);
      if (!text) return;

      if (!Object.prototype.hasOwnProperty.call(raw, key)) {
        raw[key] = text;
        return;
      }

      if (Array.isArray(raw[key])) {
        raw[key].push(text);
        return;
      }

      raw[key] = [raw[key], text];
    });

    return raw;
  }

  function pickValue(rawFields, labels) {
    for (let index = 0; index < labels.length; index += 1) {
      const key = normalizeKey(labels[index]);
      const value = rawFields[key];
      if (Array.isArray(value)) {
        const first = value.find(Boolean);
        if (first) return cleanString(first);
      }
      if (value) return cleanString(value);
    }

    return '';
  }

  function parseNumber(value) {
    const text = cleanString(value);
    if (!text) return null;

    const normalized = text.replace(/,/g, '.').replace(/[^\d.-]/g, '');
    if (!normalized) return null;

    const number = Number(normalized);
    return Number.isFinite(number) ? number : null;
  }

  function splitList(value) {
    return cleanString(value)
      .split(/\n|,|;/)
      .map((entry) => entry.trim())
      .filter(Boolean);
  }

  function collectUrls(value) {
    return Array.from(String(value || '').matchAll(/https?:\/\/\S+/gi), function (match) {
      return match[0].replace(/[),.;]+$/, '');
    });
  }

  function resolveEndpoint(section) {
    const appUrl = cleanString(
      (section && section.getAttribute && section.getAttribute('data-swish-system-app-url')) ||
      window.SWISH_SYSTEM_PUBLIC_APP_URL ||
      ''
    );

    if (!appUrl) return '';

    try {
      return new URL('/api/public/intake/theme-contact', appUrl).toString();
    } catch (error) {
      return `${appUrl.replace(/\/$/, '')}/api/public/intake/theme-contact`;
    }
  }

  function resolveInstallationKey(section) {
    return cleanString(
      (section && section.getAttribute && section.getAttribute('data-swish-multi-use-key')) ||
      window.SWISH_MULTI_USE_INSTALLATION_KEY ||
      ''
    );
  }

  function warnMissingEndpoint(section) {
    const warningTarget = (section && section.setAttribute) ? section : null;
    if (warningTarget && warningTarget.getAttribute('data-swish-intake-warning-shown') === 'true') {
      return;
    }

    const message = [
      '[SwishSystemIntake] Missing Swish System app URL.',
      'Set the court-builder intake URL to https://swish-multi-use.vercel.app',
      'so contact forms can deliver inquiries to the theme owner.'
    ].join(' ');

    if (warningTarget) {
      warningTarget.setAttribute('data-swish-intake-warning-shown', 'true');
    }

    if (typeof console !== 'undefined' && typeof console.error === 'function') {
      console.error(message, section || null);
    }

    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof window.CustomEvent === 'function') {
      window.dispatchEvent(new window.CustomEvent('swish-system-intake-warning', {
        detail: {
          reason: 'missing-endpoint',
          message: message
        }
      }));
    }
  }

  function buildStandardFormPayload(options) {
    const form = options.form;
    const section = options.section;
    const rawFields = collectRawFields(form);
    const intakeId = ensureIntakeIdField(form);
    const firstName =
      pickStructuredFieldValue(form, ['first name', 'firstname']) ||
      pickValue(rawFields, ['first name', 'firstname']) ||
      null;
    const lastName =
      pickStructuredFieldValue(form, ['last name', 'lastname', 'surname']) ||
      pickValue(rawFields, ['last name', 'lastname', 'surname']) ||
      null;
    const fullName =
      [firstName, lastName].filter(Boolean).join(' ').trim() ||
      pickStructuredFieldValue(form, ['your name', 'name', 'full name', 'customer name', 'contact name']) ||
      pickValue(rawFields, ['your name', 'name', 'full name', 'customer name', 'contact name']) ||
      null;
    const country =
      pickStructuredFieldValue(form, ['country', 'country code']) ||
      pickValue(rawFields, ['country', 'country code']) ||
      cleanString(
        window.SWISH_SYSTEM_LOCALIZATION &&
        (window.SWISH_SYSTEM_LOCALIZATION.country || window.SWISH_SYSTEM_LOCALIZATION.countryCode)
      ) ||
      null;
    const previewUrls = collectUrls(
      pickValue(rawFields, ['preview url', 'preview image', '2d preview image'])
    );
    const logoUrls = collectUrls(pickValue(rawFields, ['logo files', 'logos']));
    const uploadUrls = collectExplicitUploadUrls(form, previewUrls, logoUrls);

    return {
      intakeId: intakeId,
      source: options.source,
      formType: options.formType,
      pageUrl: cleanString(
        (section && section.getAttribute && section.getAttribute('data-contact-page-url')) ||
        window.location.href
      ) || null,
      origin: cleanString(
        (section && section.getAttribute && section.getAttribute('data-contact-page-origin')) ||
        window.location.origin
      ) || null,
      geoCountry: country,
      category:
        pickStructuredFieldValue(form, ['swish category', 'category'], { allowHidden: true }) ||
        pickValue(rawFields, ['swish category', 'category']) ||
        null,
      submittedAt: new Date().toISOString(),
      contact: {
        fullName: fullName,
        firstName: firstName,
        lastName: lastName,
        email:
          pickStructuredFieldValue(form, ['email', 'email address']) ||
          pickValue(rawFields, ['email', 'email address']) ||
          null,
        phone:
          pickStructuredFieldValue(form, ['phone number', 'phone', 'telephone', 'mobile']) ||
          pickValue(rawFields, ['phone number', 'phone', 'telephone', 'mobile']) ||
          null,
        shippingAddress:
          pickStructuredFieldValue(form, ['shipping address', 'address', 'street address']) ||
          pickValue(rawFields, ['shipping address', 'address', 'street address']) ||
          null,
        country: country,
        company:
          pickStructuredFieldValue(form, ['company name', 'company']) ||
          pickValue(rawFields, ['company name', 'company']) ||
          null
      },
      court: {
        width: parseNumber(pickStructuredFieldValue(form, ['court width', 'your court width', 'width']) || pickValue(rawFields, ['court width', 'your court width', 'width'])),
        length: parseNumber(pickStructuredFieldValue(form, ['court length', 'your court length', 'length']) || pickValue(rawFields, ['court length', 'your court length', 'length'])),
        units: (function () {
          var unitValue = cleanString(pickStructuredFieldValue(form, ['units']) || pickValue(rawFields, ['units'])).toLowerCase();
          if (unitValue === 'ft' || unitValue === 'foot' || unitValue === 'feet') {
            return 'ft';
          }
          if (unitValue === 'm' || unitValue === 'meter' || unitValue === 'meters' || unitValue === 'metre' || unitValue === 'metres') {
            return 'm';
          }
          return null;
        })(),
        officialDimensionKey: pickStructuredFieldValue(form, ['official dimensions']) || pickValue(rawFields, ['official dimensions']) || null,
        courtType: pickStructuredFieldValue(form, ['court type']) || pickValue(rawFields, ['court type']) || null,
        sports: splitList(pickStructuredFieldValue(form, ['sports', 'sport', 'sport lines']) || pickValue(rawFields, ['sports', 'sport', 'sport lines'])),
        lines: splitList(pickStructuredFieldValue(form, ['lines', 'sport lines', 'court lines']) || pickValue(rawFields, ['lines', 'sport lines', 'court lines'])),
        notes: resolveStructuredNoteValue(form) || null,
        timeline: pickStructuredFieldValue(form, ['timeline']) || pickValue(rawFields, ['timeline']) || null,
        colors: null,
        builderConfiguration: null,
        previewUrl: previewUrls[0] || null,
        shareUrl: pickStructuredFieldValue(form, ['share url']) || pickValue(rawFields, ['share url']) || null
      },
      builder: null,
      attachmentUrls: {
        previewImage: previewUrls[0] || null,
        logoFiles: logoUrls,
        uploads: uploadUrls
      },
      rawFields: rawFields
    };
  }

  async function postThemePayload(section, payload) {
    const endpoint = resolveEndpoint(section);
    const installationKey = resolveInstallationKey(section);
    if (!endpoint) {
      warnMissingEndpoint(section);
      return {
        ok: false,
        skipped: true,
        reason: 'missing-endpoint',
        error: 'Missing Swish System app URL theme setting'
      };
    }
    if (!installationKey) {
      return {
        ok: false,
        skipped: true,
        reason: 'missing-installation-key',
        error: 'Missing Swish Multi-Use installation key'
      };
    }

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify(Object.assign({}, payload, {
          _installationKey: installationKey
        }))
      });
      const result = await response.json().catch(function () { return null; });
      return {
        ok: response.ok,
        skipped: false,
        result: result
      };
    } catch (error) {
      return {
        ok: false,
        skipped: false,
        error: error && error.message ? error.message : 'unknown-error'
      };
    }
  }

  window.SwishSystemIntake = {
    buildStandardFormPayload: buildStandardFormPayload,
    ensureIntakeIdField: ensureIntakeIdField,
    postThemePayload: postThemePayload
  };
})();
